import axios from 'axios';
import AuthService from 'src/services/AuthService';
import UserService from "src/services/UserService";
import { identifyBeacon, logoutBeacon } from 'src/plugins/beacon';

const types = {
  SET_USER: 'SET_USER',
  SET_CLIENT_COUNT: 'SET_CLIENT_COUNT',
  SET_PERMISSIONS: 'SET_PERMISSIONS',
  SET_IS_LOGGED_IN: 'SET_IS_LOGGED_IN',
  SET_USER_ROLE: 'SET_USER_ROLE',
};
const state = {
  user: {},
  userClientCount: -1,
  permissions: [],
  isLoggedIn: false,
  role: 'admin'
};

const mutations = {
  [types.SET_USER]: (state, value) => {
    state.user = value;
  },
  [types.SET_PERMISSIONS]: (state, value) => {
    state.permissions = value;
  },
  [types.SET_IS_LOGGED_IN]: (state, value) => {
    state.isLoggedIn = value;
  },
  [types.SET_USER_ROLE]: (state, value) => {
    state.role = value;
  },
  [types.SET_CLIENT_COUNT]: (state, value) => {
    state.userClientCount = value;
  }
};

const actions = {
  async login({ commit, dispatch }, data) {
    await AuthService.login(data);
    commit(types.SET_IS_LOGGED_IN, true);
    await Promise.all([
      dispatch('config/getConfig', null, { root: true }),
      dispatch('refreshProfile')
    ]);
  },
  logout({ commit }) {
    AuthService.logout();
    commit(types.SET_IS_LOGGED_IN, false);
    logoutBeacon();
  },
  async refreshProfile({ commit }) {
    let userResult = await UserService.getProfile();
    commit(types.SET_USER, userResult.data);
    commit(types.SET_PERMISSIONS, userResult.data.permissions);
    identifyBeacon(userResult.data);
  }
};
const getters = {
  userInfo: state => state.user.user
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
